import { Text } from '@chakra-ui/react';
import { Banner } from '../components/Banner';
import { IncidentInfo, useIncidentStore } from '../hooks/incident-store';
import { useEffect, useState } from 'react';
import { FeatureFlag } from '../constant/feature-flags';
import { useFlag } from '@unleash/proxy-client-react';
import { concatenateLabels } from '../utils/concatenate-labels';

const parseAffectedProviders = (incidentInfo: IncidentInfo[]): string[] => {
  const affectedProviders = new Set<string>();
  incidentInfo.forEach((incident) => {
    if (incident.affectedProviders) {
      incident.affectedProviders.forEach((provider) => {
        affectedProviders.add(provider);
      });
    }
  });
  return Array.from(affectedProviders);
};

export const IncidentStatusBanner = () => {
  const incidentBannerEnabled = useFlag(FeatureFlag.ShowIncidentsNotification);

  const { hasActiveIncident, incidentInfo } = useIncidentStore();
  const [visible, setVisible] = useState(hasActiveIncident);

  useEffect(() => {
    setVisible(hasActiveIncident);
  }, [hasActiveIncident]);

  const onClose = () => {
    setVisible(false);
  };

  if (!visible || !incidentBannerEnabled) return null;

  const affectedProviders = parseAffectedProviders(incidentInfo ?? []);
  const affectedProvidersLabel = concatenateLabels(
    affectedProviders.length > 0 ? affectedProviders : ['providers'],
  );

  return (
    <div data-testid="incident-status-banner" onClick={onClose}>
      <Banner type="warn" onClose={onClose}>
        <Text>
          We&apos;re currently investigating an issue that may temporarily
          impact employers&apos; ability to connect to {affectedProvidersLabel}.
          Employers have been notified in Finch Connect and advised to try again
          if they encounter any problems.
        </Text>
      </Banner>
    </div>
  );
};
